// CompanyCustomers.customer_id (billing_system_BE) is always stored as
// "CUS_0007" — a "CUS_" prefix + a zero-padded (minimum 4 digit) sequence.
// customer/search normalizes whatever it's given (split on "_", re-pad), but
// bill/search, bill export, and print/sales-book all match this column
// exactly with no normalization — so the FE must build the exact stored
// string itself, or a user typing "7" instead of "0007" silently gets zero
// results. Building it here once means the input can stay forgiving (bare
// number, or pasted "CUS_0007") while every call site sends the same
// well-formed value.
const CUSTOMER_ID_INPUT_PATTERN = /^(cus[_-]?)?(\d+)$/i;

export const CUSTOMER_ID_VALIDATION_PATTERN = CUSTOMER_ID_INPUT_PATTERN;
export const CUSTOMER_ID_ERROR_MESSAGE =
	"Enter numbers only — the CUS_ prefix is optional (e.g. 7 or CUS_0007).";

// Normalizes a user-typed customer id into the exact "CUS_0007" form the BE
// stores/matches against. Returns "" when input is empty or not a bare
// number/optionally-CUS_-prefixed number, so callers can drop it from the
// request the same way they already drop other empty filters.
export function formatCustomerIdParam(rawInput: string | null | undefined): string {
	if (!rawInput) return "";
	const match = CUSTOMER_ID_INPUT_PATTERN.exec(rawInput.trim());
	if (!match) return "";
	const digits = match[2];
	return `CUS_${digits.padStart(4, "0")}`;
}
